import { useNavigate } from "react-router-dom";
import { useEntrepriseAvancement } from "@src/societes/useEntrepriseAvancement";
import { GatewayInfoSocieteOrias } from "@conformite/gateway";
import { ConformiteSocieteList } from "./ConformiteSocieteList";

export function ConformiteSocieteListFormationContinueIobsp() {
  const navigate = useNavigate();
  const { getEntrepriseAvancementForAssujettiAxe } = useEntrepriseAvancement();

  return (
    <ConformiteSocieteList
      defaultFilters={{
        categories: GatewayInfoSocieteOrias.CategorieIOBSPList,
      }}
      getFormAvancement={(entreprise) =>
        getEntrepriseAvancementForAssujettiAxe(
          entreprise,
          "formationContinueIobsp"
        )
      }
      title="Formation Continue IOBSP"
      onSocieteRedirect={(entreprise) => {
        navigate(`${entreprise.siren}?fromAxe`);
      }}
    />
  );
}
